import Logo from "../assets/icons/icon-512x512.png";
import { LoaderImg, LoaderWrap, LoadingDots, PreLoader } from "./Loader.style";

const Loader = () => {
  return (
    <PreLoader>
      <LoaderWrap>
        <LoaderImg alt="Home Health Notify" src={Logo} />
        <LoadingDots className="loading_dots">Loading</LoadingDots>
      </LoaderWrap>
    </PreLoader>
  );
};

export default Loader;
